import React, { useEffect, useState } from 'react'
import './Step3.scss'
import {Transfer, Button, Row, message, Col, Select} from 'antd'
import {getClientsMinPromise} from '../../../../promises'
import { useTranslation } from 'react-i18next'

const Step3 = ({formBd, prev, sendFormS3, currentUser}) => {
    const { t } = useTranslation()
    const [formFilters, setFormFilters] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);

    useEffect(() => {
      getClientsMinPromise(0, 1000, [formBd.category], null, formBd.company, formBd.area, formBd.typePerson, formBd.segment ? [formBd.segment] : null).then(response => {
          if (response.success && response.data.records.length > 0) {
          // setFormFilters(response.data)
          getFilteredClients(response.data)
          }else{
              message.error(t('messages.aml.cdi.step3.noRecipients'))
              prev()
          }
      })
    }, [])

      const getFilteredClients = (clients) => {
        const resRec = [];
        clients.records.map(rec => {
          const data = {
            key: rec.id,
            title: rec.nombre,
          };
          resRec.push(data);
        });
        setFormFilters(resRec);
      }

      const handleChange = (selectedIds) => {
        setSelectedIds(selectedIds);
      };

    return (
      <div className="step3-onb">
        <Row>
          <Col span={18}>
            <div className="step3-title">
                    { t('messages.aml.cdi.step3.heading') }
            </div>
          </Col>
          {/* <Col span={6} pull={1}>
            
          </Col> */}
        </Row>
        <Row>
          <div className="step3-transfer">
            <Col span={24}>
              <Transfer
                  dataSource={formFilters}
                  showSearch
                  filterOption={(input, option) =>
                    option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  listStyle={{
                    width: 380,
                    height: 370,
                  }}
                  operations={[t('messages.aml.cdi.step3.add'), t('messages.aml.cdi.step3.remove')]}
                  targetKeys={selectedIds}
                  onChange={handleChange}
                  render={item => item.title}
              />
            </Col>
          </div>
        </Row>
        <Row type='flex' justify='center' style={{marginTop: 20}}>
          <Col span={4}>
            
              <Button  onClick={() => prev()}>
                  { t('messages.aml.cdi.steps.prev') }
              </Button>
              <Button style={{ marginLeft: 8 }} type="primary" onClick={() => sendFormS3(selectedIds, formBd.typeDecl)}>
                  { t('messages.aml.cdi.steps.send') }
              </Button>
            
          </Col>
        </Row>
      </div>


    )
}
export default Step3
